import {useEffect, useRef, useState} from "react";
import {useStore} from "@store/appStore";
import db from "@utils/db";
import RainbowLoader from "@components/Loaders/RainbowLoader";
import {NoCourses, StudentAdminContainer} from "../StudentAdmin.styled";
import Course from "@components/StudentAdmin/Course";
import { useI18n } from '@i18n/useI18n';

interface IProps{
    data:any
    getDataFunction?: () => void
    getLog?: () => void
}

const Courses = (props:IProps) =>{
    const [edit, setEdit] = useState(null)
    const i18n = useI18n();

    const clearEdit = async () => {
        props.getDataFunction()
        setEdit(null)
    }

    return (
        <StudentAdminContainer gapOff={true}>
            <Course headers={true} even={true} />
            {props.data.length > 0?props.data.map((c,index) => <Course getLog={props.getLog} index={index} editFunction={setEdit} clearFunction={clearEdit} edit={edit === index} key={"course_" + index} even={index%2 > 0} data={c} />):<NoCourses> <span>{i18n.t('no-courses-found')}</span></NoCourses>}
        </StudentAdminContainer>
    )
}

export default Courses;